import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Kontakt = lazy(() => import("@/pages/info/Kontakt"));

export const Route = createFileRoute("/kontakt")({
  head: () => seoHead("/kontakt", { description: "Vi svarar normalt inom 24 timmar på vardagar. Välj det sätt som passar dig bäst." }),
  component: () => <Kontakt />,
});
